module.exports = __webpack_public_path__ + "static/media/CT_2019_30443A_pdf.b91cea04.pdf";